import axios from "axios";

export default function getAdminRoleDropdown({ start, length, search }) {
  const promise = new Promise((resolve, reject) =>
    axios
      .get(`/account/system-admin/api/v1/admin-role/dropdown`, {
        params: {
          start,
          length,
          search,
        },
      })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.message))
  );

  return promise;
}
